
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/add-to-slack",
      function () {
        return require("private-next-pages/resources/add-to-slack.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/add-to-slack"])
      });
    }
  